<div class="container">
  <button mat-button (click)="openInApp()" data-automation-id="open-in-app-button" class="open-in-app">
    <span>{{ 'APP.DIALOGS.MOBILE_APP.MOBILE_APP_BUTTON_LABEL' | translate }}</span>
  </button>
  <button mat-button (click)="onCloseDialog()">
    <mat-icon>close</mat-icon>
  </button>
</div>
